import axios, { AxiosInstance, AxiosError } from 'axios';
import config from 'config/environment';
import { toast } from 'react-toastify';
import { store } from 'store';
import { signOut } from 'store/modules/auth/actions';
import AppError from 'utils/AppError';

class Axios {
  public api = {} as AxiosInstance;
  constructor() {
    this.api = axios.create({
      baseURL: config.API_URL,
      // baseURL: 'http://localhost:8080',
      timeout: 30000,
    });

    this.interceptors();
  }
  interceptors() {
    this.api.interceptors.response.use(
      response => response,
      (error: AxiosError<AppError>) => {
        if (error.code === 'ERR_CANCELED') {
          return;
        } else if (error.response) {
          const { status, data } = error.response;

          if (status === 401 && data.message !== 'Login ou senha inválidos') {
            toast.warn('Sessão expirada');
            store.dispatch(signOut());
            window.location.href = '/'; // Redireciona usuário para index (login)
          }
          return Promise.reject({
            status: data.statusCode || status,
            error: data.message,
            message: data.message,
          });
        }
        return Promise.reject(error);
      },
    );
  }
}

export default new Axios().api;
